import { render, staticRenderFns } from "./BsDatePickerMonths.vue?vue&type=template&id=6fe4a110&scoped=true&"
import script from "./BsDatePickerMonths.vue?vue&type=script&lang=js&"
export * from "./BsDatePickerMonths.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe4a110",
  null
  
)

export default component.exports